import gql from 'graphql-tag';
import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
} from '@apollo/react-hooks';

const CHECK_ELIGIBILITY = gql`
  mutation (
    $applicationId: String!
    $eligibilityCheckInput: EligibilityCheckInput
  ) {
    directorEligibilityCheck(
      applicationId: $applicationId
      eligibilityCheckInput: $eligibilityCheckInput
    )
  }
`;

export const useCheckEligibility = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [checkEligibility] = useMutation(CHECK_ELIGIBILITY);
  return checkEligibility;
};
